<template>
  <div class="dynamic">
    <div v-show="loading"
         style="background: #fff; min-height: 768px;">
      <loading></loading>
    </div>
    <div v-show="!loading && works.records && works.records.length!==0">
      <div class="dynamic_box"
           v-for="(item_work,index) in works.records"
           :key="index">
        <div class="userinfo of_h pd_20 anmition_show">
          <div class="photo fc_l">

            <a href="javascript:;"
               @click="on_ucenter(item_work.authorId)"
               class="header_img">
              <img v-if="item_work.headimg"
                   :src="item_work.headimg">
              <img v-else
                   src="@/assets/image/community/nophoto.png">
            </a>

          </div>
          <div class="info fc_l of_h">
            <div class="name">{{item_work.realname}}</div>
            <div class="time">
              <!-- <strong>{{ item_work.createTime | getMoment}}</strong> -->
              发布于 
              <span v-if="item_work.createTime "
                      v-time="item_work.createTime "></span>
            </div>
          </div>
          <div class="tag fc_r"
               v-if="item_work.type==0">
            <img src="@/assets/image/community/tag.png">
          </div>

        </div>
        <div class="dynamic_context">

          <div class="title">
            <router-link :to="'/findDetail/'+item_work.topicId">{{item_work.title}}</router-link>
          </div>
          <div class="synopsis">
            {{item_work.description}}
          </div>
          <div class="images mt_15">
            <router-link tag="ul"
                         class="cover_conter"
                         :to="'/findDetail/'+item_work.topicId">
              <li v-for="(topic,index) in item_work.topicTnList"
                  :key="index"
                  class="grid-img anmition_show">
                <!-- 图片 -->
                <div v-if="topic.type==1"
                     class="li_div">
                  <img :src="topic.tnUrl"
                       class="fade_image_out cover">
                </div>

                <!-- 视频封面 -->
                <div v-if="topic.type==2"
                     class="li_div video_position">
                  <img :src="topic.tnUrl"
                       class="fade_image_out cover">

                  <div class="play_mose">
                    <img src="@/assets/image/community/play.png"
                         alt="">

                  </div>
                </div>

                <!-- 超出9张显示更多数量 -->
                <router-link :to="'/findDetail/'+item_work.topicId"
                             class="img_num _width _height"
                             v-if="item_work.topicTnList.length > index+1 &&  index+1 ==9 ">
                  +{{item_work.topicTnList.length - 9}}
                </router-link>

              </li>
            </router-link>
          </div>

        </div>
        <div class="state">
          <ul>
            <li @click="getComments(item_work.topicId,index)"
                class="state_li one"
                title="评论"><i></i>{{item_work.replyCount}}</li>
            <!-- <li class="solid">|</li> -->
            <button :class="item_work.isFavor==1?'on':''"
                    :disabled="isDisable"
                    title="点赞"
                    class="state_li two"
                    @click="getfavorTopic(item_work.topicId,index,item_work.isFavor)"><i></i>{{item_work.favorCount}}</button>
            <!-- <li class="solid">|</li> -->
            <li title="浏览"
                class="state_li four"> <i></i>{{item_work.viewCount}}</li>
          </ul>
        </div>
        <div class="edit_comment pd_15 of_h anmition_show"
             v-show="showComment==index">

          <div class="entry of_h">
            <div class="photo fc_l"
                 v-if="is_show_common == false"
                 @click="on_ucenter(isLogin_user.id)">
              <img v-if="isLogin_user.headimg"
                   :src="isLogin_user.headimg">
            </div>

            <div class="photo fc_l"
                 v-if="is_show_common == true">
              <img src="@/assets/image/common/nan.png">
            </div>

            <div class="edit fc_l">
              <textarea placeholder="说点什么"
                        v-model="commentNr"></textarea>

              <div class="null_login_common"
                   v-if="is_show_common == true">请<a href="javascript:;"
                   v-ripple="'rgba(255, 255, 255, 0.25)'"
                   @click="on_login()">登录</a> 后再进行评论
              </div>

            </div>
          </div>
          <div class="submitBtn mt_15 of_h">
            <button type="button"
                    :class="commentNr?'fc_r on':'fc_r'"
                    @click="submitComment(item_work.topicId,index)">评论</button>
          </div>

        </div>

        <div class="comments anmition_show"
             v-show="showComment==index">
          <div class="title">全部评论<strong>&nbsp;{{item_work.replyCount}}</strong></div>
          <div class="content">
            <div class="box mt_15 of_h"
                 v-for="(replis,index) in comments"
                 :key="index">
              <div class="photo fc_l">

                <div @click="on_ucenter(replis.userReply)">
                  <img v-if="replis.headimg"
                       :src="replis.headimg">
                  <img v-else
                       src="@/assets/image/common/nan.png"
                       alt="">
                </div>
              </div>
              <div class="info fc_l">
                <div class="name">{{replis.realname}}</div>
                <div class="context">
                  {{replis.replyContent}}
                </div>
                <div class="time">
                  <!-- <strong>{{replis.createTime | getMoment}} </strong> -->
                  <strong v-if="replis.createTime"
                          v-time="replis.createTime"></strong>

                </div>

              </div>
            </div>

            <div class="morecomments"
                 @click="morecomments(item_work.topicId)"
                 v-show="comments.length< item_work.replyCount">加载更多评论...</div>
            <div class="nocomments"
                 v-show="comments.length > item_work.replyCount || comments.length == item_work.replyCount">没有更多评论了
            </div>

          </div>
        </div>
      </div>

      <!--翻页-->
      <div class="_width page_data card_body mt_15">
        <el-pagination background
                       layout="prev, pager, next"
                       :hide-on-single-page="true"
                       :current-page="workspages.current"
                       @current-change="handleCurrentChange"
                       :page-size="workspages.size"
                       :total="workstotal">
        </el-pagination>
      </div>
    </div>

    <div>
      <div class="null_data"
           v-if="!loading && works.records && works.records.length==0">
        <img src="@/assets/image/common/null_data.png"
             alt="">
        <p>暂无内容...</p>
      </div>

    </div>

  </div>
</template>

<script>
import loading from '@/components/loading/loading.vue'
import { intervalTime } from '@/modules/common.js'
// import { topicFind } from '@/utils/api/communityFind.js'
import { selectReplise, replyTopic, favorTopic, integral, topicFollow } from '@/utils/api/circleDetail.js'
import { Info } from '@/utils/api/login.js'
import { getMoment } from '@/modules/time.js'

export default {
  name: "dynamic",
  props: ['childen'],
  components: {
    loading
  },
  data () {
    return {
      loading: true,
      works: [],
      workstotal: 0,
      workspages: {
        current: 1,
        size: 10,
      },
      //点赞数
      favors: 0,
      nowtime: new Date().getTime(),
      intervalTime: intervalTime,
      commentNr: "",
      showComment: -1,
      comments: [],
      commentsparames: {
        topicId: "",
        current: 1,
        size: 3
      },

      //当前用户
      user: {
        headimg: "",
        id: "",
        realname: ""
      },
      myid: '',
      is_show_common: true,
      isLogin_user: {},
      isDisable: false,//防止重复提交

    }
  },
  //注册过滤器
  filters: {
    getMoment
  },

  created () {
    this.is_login();//是否登陆
    this.router_url = this.$route.fullPath;//当前地址url
    this.myid = sessionStorage.getItem("id");
    //获取当前用户信息
    this.user.headimg = localStorage.getItem("headimg");
    this.user.id = localStorage.getItem("id");
    this.user.realname = localStorage.getItem("realname");
    // this.getTopicFind(this.workspages);
    this.data_topicFollow(this.workspages);//关注列表数据

  },
  mounted () {
  },

  computed: {
    // dateValue () {
    //   return (val) => {
    //     return this.$moment(val).fromNow();
    //   }
    // }
  },
  methods: {

    // 点击返回登录
    on_login () {
      sessionStorage.setItem('router_url', this.router_url)//活动详情
      this.$router.push(
        {
          path: '/login/?state=' + 1,
        }
      )
    },

    // 点击头像
    on_ucenter (authorId) {
      // 如果是自己
      if (this.isLogin_user.id && this.isLogin_user.id == authorId) {
        this.$router.push({ path: '/Pcenter?type=0' })
      } else {
        // 如果不是自己
        // this.$router.push({ path: '/Ucenter/' + authorId })
        this.$router.push({ path: '/Ucenter/' + authorId })
        // let routeData = this.$router.resolve({ path: '/Ucenter/' + authorId })
        // window.open(routeData.href, '_blank');
      }
    },

    // 是否登录
    is_login () {
      Info().then((res) => {
        let data = res.data;
        this.isLogin = data.isLogin
        if (this.isLogin == true) {
          this.isLogin_user = data.user
          this.is_show_common = false
        }
      })
    },

    //作品分页
    handleCurrentChange (val) {
      this.workspages.current = val;
      this.loading = true;
      // this.getTopicFind(this.workspages)
      this.data_topicFollow(this.workspages)//关注列表
      window.scrollTo(0, 0);

    },

    // 关注列表
    data_topicFollow (workspages) {
      this.loading = true

      // 
      topicFollow(workspages).then(res => {
        if (res.data.code == 200) {
          this.loading = false;
          this.works = res.data.data;
          this.workstotal = this.works.total;
        } else {
          this.loading = false;
          this.$message.error(res.data.message);
        }
      })

    },




    //获取作品数据
    // getTopicFind (workspages) {
    //   this.loading = true
    //   
    //   topicFind(workspages).then(res => {
    //     if (res.data.code == 200) {
    //       this.loading = false;
    //       this.works = res.data.data;
    //       this.workstotal = this.works.total;
    //     } else {
    //       this.loading = false;
    //       this.$message.error(res.data.message);
    //     }
    //   })

    // },



    //点赞
    getfavorTopic (id, index, isFavor) {

      // 未登录就去登录
      if (this.isLogin == true) {

        // 防止重复点击  时间1s
        this.isDisable = true
        setTimeout(() => {
          this.isDisable = false
        }, 3000)


        favorTopic({
          topicId: id
        }).then(res => {
          if (res.data.code == 200 && isFavor == 0) {
            this.$message({
              message: '点赞成功',
              type: 'success'
            })
            // this.getTopicFind(this.workspages);
            // 
            this.works.records[index].isFavor = 1
            this.works.records[index].favorCount = this.works.records[index].favorCount + 1

            // 请求积分的借口
            let prames = {
              type: '1',
              code: '203',
            }
            this.post_integral(prames);

          }
          if (res.data.code == 200 && isFavor == 1) {
            this.$message({
              message: '取消点赞成功',
              type: 'success'
            })
            // this.getTopicFind(this.workspages);
            // 
            this.works.records[index].isFavor = 0
            this.works.records[index].favorCount = this.works.records[index].favorCount - 1


            // 请求积分的借口
            let prames = {
              type: '1',
              code: '203',
            }
            this.post_integral(prames);
          }

          if (res.data.code !== 200) {
            this.$message({
              message: res.data.message,
              type: 'error'
            })
          }
        })
      } else {
        sessionStorage.setItem('router_url', this.router_url)//活动详情
        this.$router.push(
          {
            path: '/login/?state=' + 1,
          }
        )
      }



    },

    //展开评论
    getComments (topId, index) {
      this.comments = [],
        this.commentsparames.current = 1,
        this.commentsparames.topicId = topId;
      if (this.showComment != index) {
        this.showComment = index;
        this.getSelectReplise(this.commentsparames);
      } else {
        this.comments = [],
          this.showComment = -1;
      }
    },

    //提交评论
    submitComment (topId, index) {

      // 未登录就去登录
      if (this.isLogin == true) {

        let parame = { topicId: topId, replyContent: this.commentNr };
        if (this.commentNr) {
          replyTopic(parame).then((res) => {
            if (res.data.code == 200) {
              this.commentNr = "";
              this.$message({
                message: '评论信息提交成功!',
                type: 'success'
              });

              this.works.records[index].replyCount = this.works.records[index].replyCount + 1

              this.commentsparames.current = 1;
              this.commentsparames.topicId = topId;
              this.commentsparames.size = this.comments.length + 1;
              this.comments = [];
              this.getSelectReplise(this.commentsparames);
              // this.getCircleWorks();
              // 请求积分的借口
              let prames = {
                type: '1',
                code: '201',
              }
              this.post_integral(prames);
              this.loading_bool = false;

            } else {
              this.$message({
                message: "评论信息提交失败!",
                type: 'error'
              });

              sessionStorage.setItem('router_url', this.router_url)//活动详情
              this.$router.push(
                {
                  path: '/login/?state=' + 1,
                }
              )
            }
          })
        }
      } else {
        sessionStorage.setItem('router_url', this.router_url)//活动详情
        this.$router.push(
          {
            path: '/login/?state=' + 1,
          }
        )
      }

    },

    //积分
    post_integral (type) {
      integral(type).then((res) => {
        let data = res.data;
        // 
        // if (data.status !== 200) {
        //   this.$message.error(data.message);
        // }
      });
    },



    //获取评论数据
    getSelectReplise (parames) {
      selectReplise(parames).then((res) => {
        //this.loading_bool = false
        this.Replise = res.data.data;
        if (!this.Replise.records) { return };
        this.Replise.records.forEach((item) => {
          this.comments.push(item)
        });
      });
    },

    //加载更多评论
    morecomments (topId) {
      this.commentsparames.topicId = topId;
      this.commentsparames.current = this.commentsparames.current + 1;
      this.getSelectReplise(this.commentsparames);
    }

  },


}
</script>

<style lang="scss" scoped="scoped">
// 未登录
.null_login_common {
  width: 100%;
  height: 100%;
  backdrop-filter: saturate(10%) blur(10px);
  -webkit-backdrop-filter: blur(10px);
  background-color: rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.16rem;
  color: #666;
  position: absolute;
  top: 0;
  left: 0;
}

.null_login_common a {
  color: #c00;
  border: none;
  display: block;
  margin: 0 3px;
  text-align: center;

  border-bottom: 1px solid #c00;
}

.video_position {
  position: relative;
}

.play_mose {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
}
.play_mose img {
  width: 0.6rem;
}

div.dynamic {
  div.dynamic_box {
    background-color: #fff;
    border-radius: 5px;
    overflow: hidden;
    padding-bottom: 10px;

    margin-top: 15px;

    &:nth-of-type(1) {
      margin-top: 0;
    }
  }

  div.userinfo {
    height: 60px;

    div.photo {
      width: 60px;
      height: 60px;

      img {
        display: block;
        width: 60px;
        height: 60px;
        border-radius: 30px;
      }
    }

    div.info {
      width: 400px;
      padding: 10px 0 0 15px;

      div {
        height: 25px;
        line-height: 25px;

        &.name {
          font-size: 18px;
          // font-weight: bold;
        }

        &.time {
          color: #888;
          font-size: 14px;

          strong {
            color: #666;
            padding: 0 5px;
            font-family: Arial;
          }
        }
      }
    }

    div.tag {
      height: 25px;
      padding: 15px 20px 0 0;

      img {
        display: block;
        height: 25px;
      }
    }
  }

  div.dynamic_context {
    padding: 0 20px 20px 20px;
    box-sizing: border-box;

    div.title {
      height: 36px;
      line-height: 36px;
      font-size: 18px;

      a {
        color: #333;
        transition: all 0.3s;
        font-weight: 600;
      }

      a:hover {
        color: #d4011a;
      }
    }

    div.synopsis {
      max-height: 48px;
      line-height: 24px;
      font-size: 14px;
      color: #666;
      overflow: hidden;
      word-break: break-all;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;

      span {
        color: #c00;
        padding: 0 10px;
      }
    }
  }

  // .li_div {
  //   height: 4.9rem;
  //   min-width: 100%;
  //   cursor: pointer;
  //   -webkit-box-sizing: border-box;
  //   box-sizing: border-box;
  //   overflow: hidden;
  // }

  // 评论 点赞 浏览
  div.state {
    // border-top: 1px #f2f1f6 solid;
    // border-bottom: 1px #f2f1f6 solid;

    ul {
      display: flex;
      justify-content: space-between;
      width: 50%;
      align-items: center;
    }
  }
  .state_li {
    display: block;
    width: 30%;
    color: #bbb;
    height: 38px;
    line-height: 38px;
    text-align: center;
    font-family: Arial;
    cursor: pointer;
    background: none;
    border: none;
    transition: all 0.3s;
  }
  .one:hover,
  .two:hover {
    color: #c00;
  }
  .state_li .solid {
    width: 10px;
    flex-grow: 0;
    color: #d9d9d9;
  }

  i {
    display: inline-block;
    width: 40px;
    height: 20px;
    vertical-align: middle;
    margin-top: -2px;
    transition: all 0.3s;
  }

  .one {
    cursor: pointer;
  }
  .two {
    cursor: pointer;
  }
  .four {
    cursor: text;
  }

  .one i {
    background: url("../../../assets/image/community/msg.png") center 0
      no-repeat;
  }
  .one i:hover {
    background: url("../../../assets/image/community/msg.png") center -20px no-repeat;
  }

  .two i {
    background: url("../../../assets/image/community/za.png") center 0 no-repeat;
  }

  .two i:hover {
    background: url("../../../assets/image/community/za.png") center -20px no-repeat;
  }

  .four i {
    background: url("../../../assets/image/community/see.png") center 0
      no-repeat;
  }

  .on {
    color: #c00 !important;
  }
  .on i {
    background: url("../../../assets/image/community/za.png") center -20px no-repeat;
  }
  .on:hover i {
    background: url("../../../assets/image/community/za.png") center -20px no-repeat;
  }

  div.edit_comment {
    div.entry {
      div.photo {
        width: 0.6rem;
        height: 0.6rem;

        img {
          display: block;
          width: 0.6rem;
          height: 0.6rem;
          border-radius: 30px;
        }
      }

      div.edit {
        width: calc(100% - 0.7rem);
        margin-left: 0.1rem;
        position: relative;
        border-radius: 3px;
        overflow: hidden;

        textarea {
          width: 100%;
          height: 0.6rem;
          line-height: 20px;
          font-size: 0.14rem;
          border-radius: 4px;
          border: 1px #ddd solid;
          background: #f5f5f5;
          padding: 0.1rem;
          transition: all 0.3s;
          box-sizing: border-box;
        }
        textarea:hover,
        textarea:focus {
          background: #fff;
        }
      }
    }

    div.submitBtn {
      padding-right: 0;

      button {
        display: inline-block;
        width: 1rem;
        height: 0.36rem;
        line-height: 36px;
        text-align: center;
        background: #eee;
        color: #bbb;
        border: 0;
        font-size: 0.14rem;
        border-radius: 4px;
      }

      button.on {
        background: #c00;
        color: #fff !important;
      }
    }
  }
  .title a {
    color: #333;
    font-size: 16px;
  }
  div.comments {
    // border-top: 1px #ddd solid;

    div.title {
      height: 40px;
      line-height: 40px;
      padding: 0 20px;
      font-size: 14px;

      strong {
        font-family: Arial;
        padding: 0 5;
      }
    }

    div.content {
      padding: 0 20px 0px 20px;

      div.box {
        border-bottom: 1px #eee solid;
        padding-bottom: 15px;

        div.photo {
          width: 60px;
          height: 60px;
          cursor: pointer;

          img {
            display: block;
            width: 60px;
            height: 60px;
            border-radius: 30px;
          }
        }

        div.info {
          width: 738px;
          padding-left: 15px;

          div.name {
            height: 25px;
            line-height: 25px;
            font-size: 14px;
            font-weight: bold;
            color: #333;
            margin-bottom: 22px;
          }

          div.time {
            height: 25px;
            line-height: 25px;
            color: #c0c0c0;
            font-size: 14px;
            margin-bottom: 10px;

            strong {
              color: #666;
              padding: 0 5px;
              font-family: Arial;
            }
          }

          div.context {
            line-height: 25px;
            color: #737373;
            font-size: 14px;
            margin-bottom: 22px;
          }
        }
      }

      div.nocomments {
        height: 60px;
        line-height: 60px;
        text-align: center;
        color: #bbb;
        font-size: 14px;
      }

      div.morecomments {
        height: 60px;
        line-height: 60px;
        text-align: center;
        color: #888;
        font-size: 14px;
        cursor: pointer;

        &:hover {
          color: #f00;
        }
      }
    }
  }
}

// 自适应图片布局
.images {
}
.images ul {
  width: 100%;
  max-height: 894px;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  overflow: hidden;
}

// 画廊
.cover_conter {
  display: flex;
  flex-wrap: wrap;
}

// 封面
.cover {
  height: 100%;
  width: 100%;
  max-height: 894px;
  min-width: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  -webkit-transition: all 0.35s;
  transition: all 0.35s;
  background-color: #eee;
}

.grid-img div {
  height: 100%;
}

.grid-img div:hover img {
  -webkit-transform: scale(1.04);
  transform: scale(1.04);
  cursor: pointer;
}
// 更多数量
.img_num {
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.4);
  font-size: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

// 防止最后一个撑满
// .cover_conter::after {
//   content: "";
//   flex-grow: 99;
// }

.grid-img {
  display: inline-block;
  width: 292px;
  height: 292px;
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  &:only-child {
    width: 292px;
    height: auto;
    box-sizing: border-box;
  }

  &:nth-child(3n + 1):nth-last-child(2),
  &:nth-child(3n + 2):last-child {
    width: 292px;
    height: auto;
  }

  &:nth-child(3n + 2) {
    margin: 0 6px;
  }
  &:nth-child(n + 4) {
    margin-top: 6px;
  }
  &:last-child {
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/community/user_follow/follow_list.vue